__turbopack_context__.v({
  "root": "tweet-info-created-at-module__GZMM3G__root",
});
